<template>
  <div>
    <v-navigation-drawer
      clipped
      v-model="sidebar"
      app
      :style="{ top: $vuetify.application.top + 'px', zIndex: 4 }"
    >
      <v-list>
        <v-list-item-group>
          <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('pendanaan')">
                <span
                  v-if="clicked != 'pendanaan' && $route.name != 'Pendanaan'"
                  class="navText"
                >
                  Pendanaan
                </span>
                <span v-else class="navTextActive">
                  Pendanaan
                </span>
              </div>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('pinjaman')">
                <span
                  v-if="clicked != 'pinjaman' && $route.name != 'Pinjaman'"
                  class="navText"
                >
                  Pinjaman
                </span>
                <span v-else class="navTextActive">
                  Pinjaman
                </span>
              </div>
            </v-list-item-title>
          </v-list-item>

          <!-- <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('produk')">
                <span
                  v-if="clicked != 'produk' && $route.name != 'Produk'"
                  class="navText"
                >
                  Produk
                </span>
                <span v-else class="navTextActive">
                  Produk
                </span>
              </div>
            </v-list-item-title>
          </v-list-item> -->

          <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('tentang-kami')">
                <span
                  v-if="
                    clicked != 'tentang-kami' && $route.name != 'Tentang Kami'
                  "
                  class="navText"
                >
                  Tentang Kami
                </span>
                <span v-else class="navTextActive">
                  Tentang Kami
                </span>
              </div>
            </v-list-item-title>
          </v-list-item>

          <!-- <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('career')">
                <span
                  v-if="clicked != 'career' && $route.name != 'Karir'"
                  class="navText"
                >
                  Karir
                </span>
                <span v-else class="navTextActive">
                  Karir
                </span>
              </div>
            </v-list-item-title>
          </v-list-item> -->

          <v-list-item>
            <v-list-item-title>
              <div @click="changeClicked('hubungi-kami')">
                <span
                  v-if="
                    clicked != 'hubungi-kami' && $route.name != 'Hubungi Kami'
                  "
                  class="navText"
                >
                  Hubungi Kami
                </span>
                <span v-else class="navTextActive">
                  Hubungi Kami
                </span>
              </div>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>
              <div @click="toBlog">
                <span class="navText">
                  Blog
                </span>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      clipped-left
      app
      style="border-top: 2px solid #d3352c !important"
    >
      <v-app-bar-nav-icon @click="sidebar = !sidebar">
        <v-icon v-if="sidebar">mdi-close</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-items style="padding-top: 1.25rem;">
        <span class="pl-3" @click="$router.push('/')">
          <img
            style="width: 100%;"
            :src="require('../../assets/dompetkilat.png')"
            alt="John"
          />
        </span>
        
        <v-tooltip bottom color="white" content-class="elevation-2" max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <span class="pl-4" v-bind="attrs" v-on="on" style="display: flex; align-items: center; cursor: pointer;">
              <div style="color: #252525; font-size: 12px; font-weight: 600; display: flex; align-items: center;">
                Lancar = 31.60%
                <v-icon small class="ml-1" color="#252525">mdi-information</v-icon>
              </div>
            </span>
          </template>
          <div style="padding: 8px; font-family: sans-serif; color: #252525; font-size: 12px; line-height: 1.5; text-align: left;">
            Lancar = 31.60%, Dalam Perhatian Khusus = 21.78%, Kurang Lancar = 23.76%, Diragukan = 0.00%, Macet = 22.86%
          </div>
        </v-tooltip>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    sidebar: false,
    clicked: "",
  }),
  computed: {
    masterData() {
      return this.$store.state.masterData;
    },
  },
  methods: {
    changeClicked(str) {
      this.clicked = str;
      this.$router.push("/" + str);
    },
    toBlog() {
      window.location = "https://blog.dompetkilat.co.id/";
    },
    formatPercentage(value) {
      return value || value === 0 ? `${value}%` : "-";
    },
  },
};
</script>

<style>
.navTextActive {
  text-decoration: none;
  color: #252525;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.09px;
}
.navText {
  text-decoration: none;
  color: #767676;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.09px;
}
</style>
